export default "__VITE_ASSET__qBfK7fWH__"